export const FETCH_DO_RESET_PASSWORD = 'FETCH_DO_RESET_PASSWORD';
export const FETCH_DO_RESET_PASSWORD_SUCCESS = 'FETCH_DO_RESET_PASSWORD_SUCCESS';
export const FETCH_DO_RESET_PASSWORD_FAILURE = 'FETCH_DO_RESET_PASSWORD_FAILURE';